import React, { SyntheticEvent } from 'react';
import { Stack, Tabs, Tab, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { SUBJECTS } from '../constants';

const Container = styled(Stack)`
  margin-top: -32px;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;

const Title = styled(Typography)`
  color: #0f1629;
  font-size: 24px;
  font-weight: 700;
  padding: 0 20px;
  margin-top: 4px;
`;

const StyledTabs = styled(Tabs)({
  '& .MuiTabs-indicator': {
    backgroundColor: '#0AA6D1',
    height: '4px',
    borderRadius: '2px',
  },
});

const StyledTab = styled((props: { label: string; value: string }) => (
  <Tab disableRipple {...props} />
))({
  textTransform: 'none',
  fontSize: '20px',
  fontWeight: '400',
  marginRight: '40px',
  marginBottom: '2px',
  color: '#6C7589',
  '&:hover, &.Mui-selected': {
    color: '#0F1629',
    fontWeight: 'bold',
  },
  '&:last-child': {
    marginRight: '24px',
  },
});

type Props = {
  selectedValue: string;
  onChange: (value: string) => void;
};

export const TimeBackHeader = ({ selectedValue, onChange }: Props) => {
  const handleChange = (_: SyntheticEvent, newValue: string) => {
    onChange(newValue);
  };

  return (
    <Container>
      <Title>My TimeBack</Title>
      <Stack>
        <StyledTabs value={selectedValue} onChange={handleChange}>
          <StyledTab label="Summary" value="Summary" />
          {SUBJECTS.map((subject) => (
            <StyledTab key={subject} label={subject} value={subject} />
          ))}
        </StyledTabs>
      </Stack>
    </Container>
  );
};
